export default theme => ({
  image: {
    width: props => props.imageWidth || (props.cover ? '100%' : 'auto'),
    maxWidth: '100%',
    maxHeight: props => props.maxHeight || 'auto',
    height: 'auto',
    '-ms-interpolation-mode': 'bicubic',
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  bg: {
    background: '#000',
    opacity: 0.5
  },
  spacer: {
    marginTop: '75%',
  },
  placeholder: {
  },
  imageCover: {
    paddingTop: '63%'
  },
  container: {
    // margin: '15px 0',
    position: 'relative',
    background: props => props.backgroundColor || '#fff',
    overflow: 'hidden',
    textAlign: 'center',
    padding: props => props.border ? 2 : 0,
    border: props => props.border ? '1px solid #e0e0e0' : 'none',
    borderWdith: props => props.border,
    width: props => props.block ? '100%' : 'auto',
    display: 'inline-block',
  },
  circle: {
    borderRadius: '50%'
  },
  overlayShadow: {
    background: 'linear-gradient(0deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.1) 56%, rgba(0,0,0,0) 100%)',
    position: 'absolute',
    top: 0, bottom: 0, right: 0, left: 0
  }
});

